import {
  type BoothTab,
  BoothTabIdIncrease,
  type BoothTabSection,
  BoothTabSectionIdIncrease,
} from './BoothEnums.ts';

export const boothIndexFromId = (boothId: number): number => {
  const lastTwoDigits = boothId % 100;
  // Normal booths / Charity Booth
  // if (
  //   (lastTwoDigits >= 0 && lastTwoDigits <= 31) ||
  //   // Charity Booth / Special
  //   [50, 51].includes(lastTwoDigits) ||
  //   // Staff / Furality Supporter
  //   [52, 53].includes(lastTwoDigits)
  // ) {
  //   return lastTwoDigits;
  // }

  if (boothId === -1) {
    return -1;
  }

  return lastTwoDigits;

  // throw new Error(`tried highlighting unknown booth number ${boothId}`);
};

export const boothIdFromIndex = (
  index: number,
  tab: BoothTab,
  tabSection: BoothTabSection,
): number => {
  let id = index;

  // Offset by world and its section
  id += BoothTabIdIncrease[tab];
  id += BoothTabSectionIdIncrease[tabSection];

  return id;

  // Handle cases:
  // Normal booths
  // if (index >= 0 && index <= 31) {
  //   return id;
  // }
  // Charity Booth
  // if ([50].includes(index)) {
  //   return 150;
  // }
  // // EOZ
  // if ([251, 551, 751].includes(id)) {
  //   return 251;
  // }
  // // FWA
  // if ([151, 451, 851].includes(id)) {
  //   return 151;
  // }
  // // Furality Merch
  // if ([351, 651, 951].includes(id)) {
  //   return 351;
  // }
  // // Furality Supporter
  // if ([853, 952, 953].includes(id)) {
  //   return id;
  // }
  // throw new Error(
  //   `clicked on unknown booth number index ${index} (calculated id: ${id}) in world ${tab} in section ${tabSection}`,
  // );
};
